module.exports = "../images/cabins-bg.jpg?v=d0fc43d";